import { render } from "./ListCharacters.vue?vue&type=template&id=48822a0a"
import script from "./ListCharacters.vue?vue&type=script&lang=js"
export * from "./ListCharacters.vue?vue&type=script&lang=js"

import "./ListCharacters.vue?vue&type=style&index=0&id=48822a0a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__